// EO-1805: rate plans distributed exclusively to these placeholder demand
// clients (e.g. "DQDONOTTOUCH" on Row NYC, property 98384 / id 277) are
// internal-only and must never surface in the supplier portal — not in the
// rate plan listing, the ARI screens, or promotion creation.
export const HIDDEN_RATE_PLAN_CLIENT_CODES = ["DQDONOTTOUCH"];
